export enum Sex {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
}

export const friendlySex: Record<Sex, string> = {
    [Sex.MALE]: "Male",
    [Sex.FEMALE]: "Female",
}